const errorsValidation = {
  required: 'Obrigatório',
  email: 'E-mail inválido',
  phone: 'Telefone inválido',
};

export default errorsValidation;
